import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    agruparArraySerieCategories
} from '../../../business-components/Array/Array'

import {
    //COLOR,
    paletaTonsAzul,
} from '../../../business-const/Color/Color'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadraoPie,
} from '../../../business-components/Chart/Chart'

import {
    ButtonVisualizarTabela,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import tipoRecursoFinanceiroList from '../../../business-rules/List/tipoRecursoFinanceiroList'

import {
    calculaInstituicao,
} from '../estudo-form/EstudoServiceGarantiasRecursosFinanceiros'

import EstudoFormGarantiasRecursosFinanceirosDetalhado from '../estudo-form/EstudoFormGarantiasRecursosFinanceirosDetalhado'



const RecursosFinanceirosChart = ( { values, estudo, report, campoAgrupamento,
    valorPremioAnualizadoVidaInteira } ) => {

    const RecursosFinanceirosInstituicao = () => {

        let { series, categories, totalSeries } = agruparArraySerieCategories(
            [...estudo.current.recursosFinanceirosDetalhadoGrafico], campoAgrupamento, 'valor')

        if (valorPremioAnualizadoVidaInteira > 0) {

            totalSeries -= valorPremioAnualizadoVidaInteira

            let categoria

            const linhaRecursosFinanceiros =
                pesquisaList(values.recursosFinanceiros, values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira)

            if (campoAgrupamento === HARDCODE.campoAgrupamentoDescricaoTipoRecursoFinanceiro) {

                const linhaTipoRecursoFinanceiro =
                    pesquisaList(tipoRecursoFinanceiroList, linhaRecursosFinanceiros.tipoRecursoFinanceiro)

                categoria = linhaTipoRecursoFinanceiro.descricao

            } else {

                categoria = calculaInstituicao(linhaRecursosFinanceiros)
            }

            categories?.forEach( (linha, ind) => {

                if (linha === categoria) {
                
                    series[ind] -= valorPremioAnualizadoVidaInteira
                }
            })
        }

        let total = 0
        let criCraDebenture = 0

        if (campoAgrupamento === HARDCODE.campoAgrupamentoDescricaoTipoRecursoFinanceiro) {

            estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado?.forEach( (linha, ind) => {

                if (
                        (
                            linha.tipoRecursoFinanceiro === HARDCODE.idTipoRecursoFinanceiroInflacao ||
                            linha.tipoRecursoFinanceiro === HARDCODE.idTipoRecursoFinanceiroPosFixado ||
                            linha.tipoRecursoFinanceiro === HARDCODE.idTipoRecursoFinanceiroPreFixado ||
                            linha.tipoRecursoFinanceiro === HARDCODE.idTipoRecursoFinanceiroRendaFixa ||
                            linha.tipoRecursoFinanceiro === HARDCODE.idTipoRecursoFinanceiroRendaVariavel

                        ) &&
                        (
                            linha.descricao.indexOf('CRI ') !== -1 ||
                            linha.descricao.indexOf('CRI-') !== -1 ||
                            linha.descricao.indexOf('CRA ') !== -1 ||
                            linha.descricao.indexOf('CRA-') !== -1 ||
                            linha.descricao.indexOf('DEBÊNTURE ') !== -1 ||
                            linha.descricao.indexOf('DEB ') !== -1
                        )
                ) {

                    criCraDebenture += linha.valor
                }

                total += linha.valor
            })
        }



        return (
            <>
                <ChartPadraoPie
                    series={series}
                    width={report ? 450 : 550}////{report ? 320 : 360}
                    height={report ? 450 : 550}////{report ? 320 : 360}
                    //endAngle={90}
                    labels={categories}
                    //fillOpacity={0.9}
                    fillType='gradient'
                    ////fillShadeIntensity={0.3}
                    legendPosition={''}
                    paletaCores={paletaTonsAzul}
                    ////dataLabelsColor={COLOR().corChartPadraoAnalisePatrimonialLegendaGraficoPizza}
                    labelsSomentePerc={false}
                    totalSeries={totalSeries}
                />

                {campoAgrupamento === HARDCODE.campoAgrupamentoDescricaoTipoRecursoFinanceiro && (
                    <>
                        {criCraDebenture > 0 && (
                            <GridItem12
                                className='mt-2 mb-3'
                                align='center'
                            >
                                {LABEL.criCraDebenture + ' = ' + formataValor(criCraDebenture, 2) + ' (' +
                                    formataPerc(criCraDebenture / total * 100, 2) + ')'
                                }
                            </GridItem12>
                        )}

                        {!report && (
                            <CustomizedDialogsPopup
                                maxWidth='xl'
                                popupTitle={
                                    //campoAgrupamento === HARDCODE.campoAgrupamentoInstituicao
                                    //    ?
                                    //        LABEL.recursosFinanceiros.toUpperCase() + ': ' +
                                    //            LABEL.instituicao + ' x ' +
                                    //                LABEL.tipoRecursoFinanceiro
                                    //    :
                                            LABEL.recursosFinanceiros.toUpperCase() + ': ' +
                                                LABEL.tipoRecursoFinanceiro + ' x ' +
                                                    LABEL.instituicao
                                }
                                PopupButton={ButtonVisualizarTabela}
                                popupComponent={
                                    <EstudoFormGarantiasRecursosFinanceirosDetalhado
                                        values={values}
                                        estudo={estudo}
                                        report={report}
                                        popup={true}
                                        recursosFinanceirosDetalhado={
                                            //campoAgrupamento === HARDCODE.campoAgrupamentoInstituicao
                                            //    ?
                                            //        estudo.current.recursosFinanceirosDetalhado
                                            //    :
                                                    estudo.current.recursosFinanceirosTipoRecursoFinanceiroDetalhado
                                        }
                                        detalhadoTipoRecurso={
                                            //campoAgrupamento === HARDCODE.campoAgrupamentoInstituicao
                                            //    ?
                                            //        false
                                            //    :
                                                    true
                                        }
                                    />
                                }
                            />
                        )}
                    </>
                )}
            </>
        )
    }

    return (
        <RecursosFinanceirosInstituicao/>
    )
}

export default RecursosFinanceirosChart